module.exports = __webpack_public_path__ + "static/battle01-2e12fa3ced365f39b94c8853ea933447.png";